<script setup lang="ts">
import tableSymbolDark from '@/common/assets/table-symbol-dark.svg';
import lightTableSymbol from '@/common/assets/table-symbol-light.svg';

import NoDataContent from '@/common/components/molecules/noData/NoDataContent.vue';
import BaseButton from '@/common/components/molecules/baseButton/BaseButton.vue';

import { useRouter } from 'vue-router';
import { storeToRefs } from 'pinia';

import { useBaseMenuStore } from '@/common/stores/base-menu';

import { useInternational } from '@/common/locale';
import { getCurrentTheme } from '@/common/utils/commonUtils';

const router = useRouter();

const baseMenuStore = useBaseMenuStore();
const { isShowMenuSearch } = storeToRefs(baseMenuStore);

const { t } = useInternational();

const theme = getCurrentTheme();
const imgSrc = theme === 'dark' ? tableSymbolDark : lightTableSymbol;

const onClickDashboardGuideButton = () => {
  isShowMenuSearch.value = false;

  router.push({
    path: '/dashboard/list',
  });
};
</script>

<template>
  <div class="menu-search-empty">
    <no-data-content>
      <template #icon>
        <img
          :src="imgSrc"
          alt="symbol"
          draggable="false"
          style="width: 80px; height: 80px"
        />
      </template>
      <template #message>
        {{ t('MESSAGE.GNB_SEARCH_DEFAULT_EMPTY_MESSAGE') }}

        <div class="menu-search-empty__guide">
          <base-button
            type="default"
            size="medium"
            class="shape-border menu-search-empty__guide-button"
            @click="onClickDashboardGuideButton"
          >
            {{ `${t('WORD.DASHBOARD')} ${t('WORD.GNB.HELP.GUIDE')}` }}
            <ev-icon icon="icon-arrow-right" />
          </base-button>
        </div>
      </template>
    </no-data-content>
  </div>
</template>

<style scoped lang="scss">
.menu-search-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;

  &__guide-button {
    display: inline-flex;
    gap: 4px;
    align-items: center;

    i {
      mask-size: 15px 15px;
    }
  }

  :deep(.no-data-content__message) {
    display: flex;
    flex-direction: column;
    gap: 16px;
    color: var(--color-gray-02-10);
  }
}
</style>
